module.exports = __webpack_public_path__ + "c33116cf.svg";